import TransInternationalWrapper from "@/modules/transfer-money/transfer-international/TransInternationalWrapper";
import React from "react";

const TransInternational: React.FC = () => {
  return <TransInternationalWrapper />;
};

export default TransInternational;
